<bav-reporting-feature-ais-reports-report-details
  #withIsChangedSupport
  *ngIf="initialState$ | async as initialState"
  [initialState]="initialState"
></bav-reporting-feature-ais-reports-report-details>
